import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, LogOut } from 'lucide-react';
import { supabase } from '../supabase/client';
import LogoWithFallback from '../components/LogoWithFallback';

export default function TermsOfService() {
  const navigate = useNavigate();
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    const getSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session?.user) {
        setUser(session.user);
      }
    };
    getSession();

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });
    return () => subscription.unsubscribe();
  }, []);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    setUser(null);
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b border-gray-100">
        <div className="max-w-6xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3 hover:opacity-90 transition-opacity">
              <LogoWithFallback className="h-10 w-10 object-contain" />
            </Link>
            <div className="flex items-center gap-3">
              <Link to="/" className="flex items-center gap-1.5 px-4 py-2 text-sm text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors">
                <ArrowLeft className="w-4 h-4" />返回首页
              </Link>
              {user ? (
                <>
                  <span className="text-sm text-gray-700">{user.phone}</span>
                  <button onClick={handleLogout} className="flex items-center gap-1 px-4 py-2 text-sm text-red-600 hover:bg-red-50 rounded-lg transition-colors">
                    <LogOut className="w-4 h-4" />退出
                  </button>
                </>
              ) : (
                <>
                  <Link to="/login" className="px-4 py-2 text-sm text-gray-600 hover:text-blue-600 transition-colors">登录</Link>
                  <Link to="/register" className="px-5 py-2 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">注册</Link>
                </>
              )}
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">用户协议</h1>
        <div className="bg-white rounded-2xl border border-gray-100 p-8 space-y-6 text-gray-600">
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">一、服务条款</h2>
            <p>欢迎使用编程优题库平台服务。本协议是您与编程优题库之间关于使用本平台服务的协议。请您仔细阅读本协议，如您不同意本协议的任何内容，请停止使用本平台服务。</p>
          </section>
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">二、账号注册</h2>
            <p>您需要注册账号才能使用本平台的部分服务。注册时您需要提供真实、准确的个人信息，并妥善保管您的账号密码。因您保管不善导致的账号被盗用，本平台不承担责任。</p>
          </section>
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">三、用户行为规范</h2>
            <p>您在使用本平台服务时，应遵守国家法律法规，不得发布违法违规内容，不得侵犯他人合法权益，不得从事任何损害本平台利益的行为。</p>
          </section>
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">四、知识产权</h2>
            <p>本平台的所有内容，包括但不限于文字、图片、音频、视频、软件等，均受知识产权法律保护。未经授权，您不得复制、传播、修改或以其他方式使用本平台内容。</p>
          </section>
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">五、免责声明</h2>
            <p>本平台尽力提供准确、完整的信息，但不保证信息的绝对准确性和完整性。对于因使用本平台服务而产生的任何损失，本平台不承担责任，除非法律另有规定。</p>
          </section>
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">六、协议修改</h2>
            <p>本平台有权随时修改本协议，修改后的协议将在平台上公布。如您继续使用本平台服务，视为您接受修改后的协议。</p>
          </section>
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">七、联系我们</h2>
            <p>如您对本协议有任何疑问，请联系我们的客服团队：support@udo100.com</p>
          </section>
        </div>
      </main>
    </div>
  );
}
